import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import axios from 'axios';
import { urlConfig } from '../../config/urlConfig';
import Cookies from 'js-cookie';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import { CreateMeetingContext } from '../../services/create-meeting/create-meeting.context';
import { ProfileContext } from '../../services/profile/profile.context';

const useStyle = makeStyles((theme) => {
  return {
    wrapper: {
      position: 'relative',
      margin: '10px 0',
      width: 'max-content',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
    },
    list: {
      padding: 0,
    },
  };
});

const Place = () => {
  const classes = useStyle();

  const { states } = useContext(CreateMeetingContext);
  const { users, setLocation } = states;
  const { user } = useContext(ProfileContext);

  const [open, setOpen] = useState(false);
  const [places, setPlaces] = useState('');
  const [error, setError] = useState('');
  const [type, setType] = useState('');
  const [typeError, setTypeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState({
    visible: false,
    value: 'No location found',
  });

  const sendEmails = (e) => {
    const userData = [];

    users && users.length > 0 && users.map((user) => userData.push(user.username));

    if (type === '') {
      setTypeError(true);
    } else if (users && users.length > 0) {
      setLoading(true);
      setTypeError(false);
      axios
        .post(urlConfig.refresh_token_url, {
          refresh: Cookies.get('refresh_token'),
        })
        .then((res) => {
          axios
            .post(
              urlConfig.get_places,
              {
                users: [...userData, user && user.username],
                term: type,
              },
              {
                headers: {
                  Authorization: `Bearer ${res.data.access}`,
                },
              }
            )
            .then((res) => {
              setError('');
              setNotFound({ ...notFound, visible: false });

              if (
                res.data &&
                res.data.suggested &&
                res.data.suggested.features &&
                res.data.suggested.features.length > 0
              ) {
                setPlaces(res.data);
                setOpen(true);
                setNotFound({ ...notFound, visible: false });
              } else if (res.data.prefences && res.data.prefences.length > 0) {
                setPlaces(res.data);
                setOpen(true);
                setNotFound({ ...notFound, visible: false });
              } else {
                setNotFound({ ...notFound, visible: true });
              }
              setLoading(false);
            })
            .catch((err) => {
              setError(err.message);
              setLoading(false);
              setNotFound({ ...notFound, visible: false });
            });
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
          setNotFound({ ...notFound, visible: false });
        });
    } else {
      setNotFound({ ...notFound, visible: false });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    setType(event.target.value);
  };

  return (
    <>
      <FormControl style={{ minWidth: 300 }}>
        <InputLabel id='select-plcae'>
          please select your favourite places
        </InputLabel>
        <Select
          labelId='select type'
          value={type}
          onChange={handleChange}
          error={typeError}
        >
          <MenuItem value={'cafe'}>Cafe</MenuItem>
          <MenuItem value={'restaurant'}>Restaurant</MenuItem>
          <MenuItem value={'fastfood'}>Fast food</MenuItem>
        </Select>
      </FormControl>

      <Box mt={4} className={classes.wrapper}>
        <Button
          variant='contained'
          fullWidth
          disabled={loading}
          onClick={sendEmails}
          size='small'
        >
          places
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </Box>
      <Box>
        {error && (
          <Typography variant='caption' color='error'>
            {error}
          </Typography>
        )}
        {notFound.visible && (
          <Typography variant='caption'>{notFound.value}</Typography>
        )}
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <List className={classes.list}>
          {places &&
            places.prefences.length > 0 &&
            places.prefences.map((item, index) => (
              <React.Fragment key={`${index}-${item.lng}`}>
                <ListItem
                  button
                  onClick={() => {
                    setLocation({
                      lat: item.location.lat,
                      lng: item.location.lng,
                    });
                    setOpen(false);
                  }}
                >
                  <ListItemText
                    primary={`* ${item.location.name}`}
                    secondary={item.location.address}
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          {places &&
            places.suggested.features &&
            places.suggested.features.map((item) => (
              <React.Fragment key={item.geometry.coordinates}>
                <ListItem
                  button
                  onClick={() => {
                    setLocation({
                      lat: item.geometry.coordinates[1],
                      lng: item.geometry.coordinates[0],
                    });
                    setOpen(false);
                  }}
                >
                  <ListItemText
                    primary={
                      item.properties.name
                        ? item.properties.name
                        : item.properties.address_line2
                    }
                    secondary={item.properties.address_line2}
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          <ListItem>
            {places && places.prefences.locations && (
              <Typography variant='h6'>{places.prefences.locations}</Typography>
            )}
          </ListItem>
        </List>
      </Dialog>
    </>
  );
};

export default Place;
